









































import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator';

import ModelSetter from "../../Mixins/ModelSetter";
import CapsLockIsActiveMessage from "../../components/Auth/CapsLockIsActiveMessage.vue";
import PasswordInput from "../../components/Pi/fields/PasswordInput/PasswordInput.vue";
import AuthPasswordMixin from "../../logic/auth/AuthPasswordMixin";
import { PASSWORD_MIN_SYMBOLS } from '../../logic/auth/logic';

@Component({
  data(){
    return {
      PASSWORD_MIN_SYMBOLS
    }
  },
  components: {
    CapsLockIsActiveMessage,
    PasswordInput
  }
})
export default class NewPasswordFields extends Mixins(ModelSetter, AuthPasswordMixin) {
  @PropSync('password') pass!: string

  @PropSync('confirmPassword') confirmPass!: string

  @Prop() arePasswordsEqual!: boolean
}
